(ns frontend.components.drag-layout
  (:require [ui.dom-globals :as dg]
            [ui.util :as uu]
            [reagent.core :as r]))

(defn top-bottom [drag-state _class-name _top _bottom]
  (let [layout-atom (atom {})
        mouse-up-handler (fn [_]
                           (swap! drag-state dissoc :unselectable?)
                           (swap! layout-atom dissoc :dragging?))
        mouse-move-handler (fn [e]
                             (when (:dragging? @layout-atom)
                               (let [container-offset-top (-> @layout-atom
                                                              :drag-container
                                                              (dg/offset-top))
                                     pointer-relative-y (- (dg/client-y e) container-offset-top)
                                     min-top-height 60
                                     top-height (max min-top-height (- pointer-relative-y 8))]
                                 (swap! drag-state assoc :top-height top-height))))]
    (.addEventListener js/document "mouseup" mouse-up-handler)
    (.addEventListener js/document "mousemove" mouse-move-handler)
    (r/create-class
     {:component-will-unmount
      (fn [_]
        (.removeEventListener js/document "mouseup" mouse-up-handler)
        (.removeEventListener js/document "mousemove" mouse-move-handler))
      :reagent-render
      (fn [drag-state class-name top bottom]
        (let [{:keys [top-height unselectable?]} @drag-state]
          [:div
           {:class-name (uu/cm class-name
                               "d-flex flex-column top-bottom-draggable"
                               (when unselectable?
                                 "unselectable"))
            :ref        (fn [c]
                          (when c
                            (swap! layout-atom assoc :drag-container c)))}
           [:div.draggable-top
            {:style (merge
                     (when top-height
                       {:height    top-height
                        :flex-grow 0}))}
            top]
           [:div.top-bottom-divider
            [:div.top-bottom-drag-handle
             {:on-mouse-down (fn [_]
                               (swap! drag-state assoc :unselectable? true)
                               (swap! layout-atom assoc :dragging? true))}]]
           [:div.draggable-bottom
            bottom]]))})))

(defn left-right [drag-state _class-name _left _right]
  (let [layout-atom (atom {})
        mouse-up-handler (fn [_]
                           (swap! drag-state dissoc :unselectable?)
                           (swap! layout-atom dissoc :dragging?))
        mouse-move-handler (fn [e]
                             (when (:dragging? @layout-atom)
                               (let [container (-> @layout-atom :drag-container)
                                     container-offset-left (dg/offset-left container)
                                     pointer-relative-x (- (dg/client-x e) container-offset-left)
                                     min-left-width 60
                                     left-width (max min-left-width (- pointer-relative-x 8))
                                     container-width (dg/client-width container)
                                     right-width (- container-width left-width)]
                                 (swap! drag-state assoc
                                        :left-width left-width
                                        :right-width right-width))))]
    (.addEventListener js/document "mouseup" mouse-up-handler)
    (.addEventListener js/document "mousemove" mouse-move-handler)
    (r/create-class
     {:component-will-unmount
      (fn [_]
        (.removeEventListener js/document "mouseup" mouse-up-handler)
        (.removeEventListener js/document "mousemove" mouse-move-handler))
      :reagent-render
      (fn [drag-state class-name left right]
        (let [{:keys [left-width right-width unselectable?]} @drag-state]
          [:div
           {:class-name (uu/cm class-name
                               "flex bg-base-light relative flex-1"
                               (when unselectable?
                                 "unselectable"))
            :ref        (fn [c]
                          (when c
                            (swap! layout-atom assoc :drag-container c)))}
           [:div
            {:class "min-w-[25%] relative"
             :style (when (number? left-width)
                      {:width     (str left-width "px")
                       :flex-grow 0})}
            left]
           [:div
            [:div
             {:class "-ml-4 w-8 h-8 flex justify-center items-center rounded-full bg-secondary-regular text-secondary-regular-text absolute top-0 cursor-col-resize"
              :on-mouse-down (fn [_]
                               (swap! drag-state assoc :unselectable? true)
                               (swap! layout-atom assoc :dragging? true))}
             [:i.fal.fa-regular.fa-arrows-left-right]]]
           [:div
            {:class "w-9/12"
             :style (when (number? right-width)
                      {:width     (str right-width "px")
                       :flex-grow 0})}
            right]]))})))
